import { render, staticRenderFns } from "./choices2.vue?vue&type=template&id=1bc7f626&"
import script from "./choices2.vue?vue&type=script&lang=js&"
export * from "./choices2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports